import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import EmptyState from 'components/reusables/emptyState'
import { AccessToCoursesEnum } from 'enum/accessToCourses'
import { useRolesAndPermissions } from '../../../context/RolesAndPermissionsContext'
import { Container, Header, Title, Content, Alert } from './styled'
import Courses from './courses'
import AddCourses from './addCourses'

const AccessToCourses = () => {
  const { t } = useTranslation()
  const { roleDetail: data } = useRolesAndPermissions()
  const isPermissionsDisabled = data.isDefault
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToCourses'
  const [isOpen, setIsOpen] = useState(true)
  const [showAddCourse, setShowAddCourse] = useState(false)

  return (
    <Container>
      <Header onClick={() => setIsOpen(!isOpen)}>
        <Button type="link">
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </Button>
        <Title>{t(`${prefix}.title`)}</Title>
      </Header>
      <Content open={isOpen} disabled={isPermissionsDisabled}>
        <Alert>
          <FontAwesomeIcon icon={faInfoCircle as IconProp} />
          {t(`${prefix}.alert`)}
        </Alert>
        {data.accessToCourses === AccessToCoursesEnum.None && (
          <EmptyState
            title={t(`${prefix}.emptyState.title`)}
            icon={faGraduationCap as IconProp}
            iconSize="small"
            action={() => setShowAddCourse(true)}
            actionTitle={t(`${prefix}.emptyState.action`)}
            actionIcon={faPlus as IconProp}
            actionDisabled={isPermissionsDisabled}
          />
        )}
        {data.accessToCourses === AccessToCoursesEnum.All && (
          <EmptyState
            title={t(`${prefix}.allCourses.title`)}
            icon={faGraduationCap as IconProp}
            iconBackground="#CFE7FD"
            iconColor="#213F68"
            iconSize="small"
            action={() => setShowAddCourse(true)}
            actionTitle={t(`${prefix}.allCourses.action`)}
            actionIcon={faPlus as IconProp}
            actionDisabled={isPermissionsDisabled}
          />
        )}
        {data.accessToCourses === AccessToCoursesEnum.Specific && (
          <Courses
            addCourse={() => setShowAddCourse(true)}
            disabled={isPermissionsDisabled}
          />
        )}
      </Content>
      {showAddCourse && !isPermissionsDisabled && (
        <AddCourses close={() => setShowAddCourse(false)} />
      )}
    </Container>
  )
}

export default AccessToCourses
